<template>
  <div class="hospitalInfo">
    <img :src="hospitalInfo.imgUuid" alt="">
    <div class="info">
      <h2 class="name">{{hospitalInfo.name}}</h2>
      <p class="rank">{{hospitalInfo.level}}</p>
      <p class="area">{{hospitalInfo.area}}</p>
      <p class="detail" v-html="hospitalInfo.introduction"></p>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['hospitalInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
.hospitalInfo{
  overflow: hidden;
  width: 557px;
  box-sizing: border-box;
  margin-bottom: 20px;
  img{
    float: left;
    display: block;
    width: 180px;
    height: 180px;
    margin-right: 20px;
    background: #ddd;
  }
  .name{
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 700;
  }
  .rank{
    margin-bottom: 19px;
    font-weight: 700;
    color:#61aee6;
  }
  .detail{
    height: 98px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    line-height: 20px;
    margin-top:10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/HospitalInfo.vue